import React from 'react'
import { FaAndroid, FaBootstrap, FaCss3, FaGit, FaHtml5, FaNodeJs, FaPython, FaReact } from 'react-icons/fa'

function Courosel() {
    return (
        <div>
            <div className="courosel-parent position-relative" id='courosel'>
                <h1 className="position-absolute top-0 start-0 end-0 text-center mt-10 ">Technologies I Used</h1>
                <div className='gallery'>
                    <span style={{ '--i': 1 }}>
                        <FaReact color='cyan' />
                    </span>
                    <span style={{ '--i': 2 }}>
                        <FaPython color='darkBlue' />
                    </span>
                    <span style={{ '--i': 3 }}>
                        <FaGit color='orange' />
                    </span>
                    <span style={{ '--i': 4 }}>
                        <FaHtml5 color='orangered' />
                    </span>
                    <span style={{ '--i': 5 }}>
                        <FaCss3 color='blue' />
                    </span>
                    <span style={{ '--i': 6 }}>
                        <FaBootstrap color='purple' />
                    </span>
                    <span style={{ '--i': 7 }}>
                        <FaNodeJs color='green' />
                    </span>
                    <span style={{ '--i': 8 }}>
                        <FaAndroid color='yellow' />
                    </span>
                </div>
            </div>
        </div>
    )
}

export default Courosel
